import { FC, Fragment } from 'react';
// i18next
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
// Types
import UserRoles from 'app/types/UserRoles';
// Models
import { IMyUser } from 'app/models/User';
// Redux
import { useAppSelector } from 'app/hooks/useStore';
// Selectors
import { selectMyUser } from 'app/store/Users/Users.selectors';
// Mui
import { Divider, ListItemButton, ListItemText } from '@mui/material';

type Props = {
  onClose: () => void;
}

const AdminMenuItems:FC<Props> = ({ onClose }) => {
  const { t } = useTranslation();
  // State
  const myUser:IMyUser | null = useAppSelector(selectMyUser);

  const listItems = [
    { to: '/admin/cases', type: 'item', label: t('components.userDrawer.cases') },
    { to: '/admin/users', type: 'item', label: t('components.userDrawer.casePortalUsers') },
    { to: '/admin/teams', type: 'item', label: t('components.userDrawer.casePortalTeams') },
    { to: '/admin/client-accounts', type: 'item', label: t('components.userDrawer.clientAccounts') },
    { to: '/admin/author-registry', type: 'item', label: t('components.userDrawer.authorRegistry') },
    { to: '/admin/terms-and-conditions', type: 'item', label: t('components.userDrawer.termsAndConditions') },
    { to: '/admin/document-collections', type: 'item', label: t('components.userDrawer.documentCollections') },
    { type: 'divider' },
    { to: '/admin/company-account', type: 'item', label: t('components.userDrawer.companyAccount') },
    { to: '/admin/billing-and-subscriptions', type: 'item', label: t('components.userDrawer.billingAndSubscriptions') },
    { to: '/admin/calendar', type: 'item', label: t('components.userDrawer.companyCalendar') },
    { to: '/admin/contacts', type: 'item', label: t('components.userDrawer.contacts') },
    { type: 'divider' },
    { to: '/admin/presets', type: 'item', label: t('components.userDrawer.reportPresets') },
    { to: '/admin/templates', type: 'item', label: t('components.userDrawer.templates') },
    { to: '/admin/ai-prompt-hub', type: 'item', label: t('components.userDrawer.aiPromptHub') },
    { to: '/admin/automated-workflows', type: 'item', label: t('components.userDrawer.automatedWorkflows') },
    { type: 'divider' }
  ];

  if ( !myUser || myUser.role !== UserRoles.Admin ) return null;
  return (
    <Fragment>
      {listItems.map((listItem:any, index:number) => {
        if ( listItem.hidden ) return null;
        if ( listItem.type === 'divider' ) return (
          <Divider key={`user menu list divider ${index}`} component="li" />
        );
        return (
          <ListItemButton
            key={`user menu list item ${index}`}
            component={Link}
            to={listItem.to}
            onClick={onClose}
            sx={{ textTransform: 'capitalize' }}
          ><ListItemText primary={listItem.label} /></ListItemButton>
        );
      })}
    </Fragment>
  )
}

export default AdminMenuItems;
